module.exports = __webpack_public_path__ + "static/media/Simple_02.f6e88616.png";